// extracted by mini-css-extract-plugin
export default {"collapsible":"segment-branding-form_collapsible__e1aYs","formHeader":"segment-branding-form_formHeader__XKXGL"};